import React, { FunctionComponent, ReactNode, useCallback, useEffect, useState } from 'react';
import { fetchRequest } from '../../../../../api/fetch';
import { useMenuItemStyles } from './MenuItem.styles';

interface IMenuItemProps {
  icon: ReactNode;
  title: string;
  counter?: number | undefined;
}

const useIsMobile = (breakpoint = 768): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

const EventMenuItem: FunctionComponent<IMenuItemProps> = ({ icon, title, counter }) => {
  const classes = useMenuItemStyles();
  const [loading, setLoading] = useState(false);
  const isMobile = useIsMobile();

  const handleClick = useCallback(async () => {
    if (loading) return; // Prevent multiple clicks

    setLoading(true);

    try {
      const response = await fetchRequest('/members/me/zarrangement/remote-login-url');

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const url = await response.text();

      if (isMobile) {
        window.location.href = url;
      } else {
        window.open(url, '_blank');
      }
    } catch (error) {
      console.error('Failed to fetch URL', error);
    } finally {
      setLoading(false);
    }
  }, [loading, isMobile]);

  return (
    <button type="button" onClick={handleClick} className={`${classes.link} ${classes.button}`}>
      <div className={classes.root}>
        <div className={classes.icon}>{icon}</div>
        <div className={classes.title}>
          {title}
          {counter ? <div className={classes.counter}>{counter}</div> : null}
        </div>
      </div>
    </button>
  );
};

export default EventMenuItem;
